import RestService from './RestService';

// Super-panel views over webhook entities and their deliveries. Both lists are
// server-paged; RestService.list already forwards the filter/paging query, so
// there is nothing to add here beyond the two manual actions.
export class SuperWebhooks extends RestService {
    constructor() {
        super('/superWebhooks');
    }
}

export class SuperWebhookEvents extends RestService {
    constructor() {
        super('/superWebhookEvents');
    }

    // The per-webhook table on a webhook's detail page is `list({ webhookId })`,
    // which is why there is no separate method for it.
    runNow(eventId) {
        return this.post(`${this.baseUrl}/${eventId}/run-now`);
    }

    reschedule(eventId, nextTry) {
        return this.put(`${this.baseUrl}/${eventId}/next-try`, { nextTry });
    }
}
